import type { ParamSpec } from '@/lib/checkpoint/types';

interface Props {
  parameters: ParamSpec[];
  values: Record<string, string | number | boolean>;
  onChange: (next: Record<string, string | number | boolean>) => void;
  /** 字段级错误信息，来自服务端 validate 或 ParamError。 */
  errors?: Record<string, string>;
  compact?: boolean;
}

export function ParamForm({ parameters, values, onChange, errors, compact }: Props) {
  if (!parameters || parameters.length === 0) {
    return (
      <p className="text-[11px] text-ink-muted">本套件没有参数。</p>
    );
  }
  const update = (name: string, raw: string | number | boolean): void => {
    onChange({ ...values, [name]: raw });
  };
  return (
    <div className={compact ? 'space-y-1.5' : 'space-y-2.5'}>
      {parameters.map((p) => {
        const cur = values[p.name];
        const err = errors?.[p.name];
        const placeholder = p.example ?? p.description;
        return (
          <label key={p.name} className="block text-[11px]">
            <div className="flex items-baseline gap-1.5">
              <span className="font-medium text-ink">{p.label ?? p.name}</span>
              {p.required && <span className="text-rose-400">*</span>}
              <span className="text-ink-dim">({p.type})</span>
            </div>
            {p.description && !compact && (
              <p className="mt-0.5 text-ink-muted">{p.description}</p>
            )}
            {p.type === 'boolean' ? (
              <select
                className="input mt-1 w-full"
                value={cur === undefined || cur === '' ? '' : String(cur)}
                onChange={(e) => update(p.name, e.target.value === 'true')}
              >
                <option value="">(默认)</option>
                <option value="true">true</option>
                <option value="false">false</option>
              </select>
            ) : (
              <input
                className="input mt-1 w-full font-mono"
                placeholder={placeholder}
                type={p.type === 'number' ? 'number' : 'text'}
                value={cur === undefined ? '' : String(cur)}
                onChange={(e) =>
                  update(
                    p.name,
                    p.type === 'number'
                      ? Number(e.target.value)
                      : e.target.value,
                  )
                }
              />
            )}
            {err && <p className="mt-0.5 text-rose-400">{err}</p>}
          </label>
        );
      })}
    </div>
  );
}
